module.exports = __webpack_public_path__ + "0662401d69e66a5222c62a3860efd047.png";